import {Button} from 'utils';
import {SuccessIcon} from 'assets/icons';

const DETAILS = [
    {key: 'business_name', label: 'Business Name'},
    {key: 'merchant_name', label: 'Merchant Name'},
    {key: 'country', label: 'Country'},
];

export const FacialVerificationInfo = ({merchant = {}, onProceed}) => (
    <div className="merchant_info text-center">
        <h3 className="fw-bold mt-2">Confirm Your Details</h3>
        <p className="pb-2 pt-1 font-13">
            Please confirm the details below before starting facial verification.
        </p>

        <div className="merchant_info-list text-start">
            {DETAILS.map(({key, label}) => (
                <div className="merchant_info-row" key={key}>
                    <span>{label}</span>
                    <p>{merchant?.[key] || 'Not Available'}</p>
                </div>
            ))}
        </div>

        <div className="col-7 mx-auto mt-5">
            <Button name="Continue" cls="btn--lg" handleClick={onProceed} />
        </div>
    </div>
);

export const FacialVerificationRejected = ({onRedo, data}) => (
    <div className="verification_result text-center">
        <h4 className="fw-bold">Your Facial Verification could not be completed.</h4>

        {data?.logicFailed ? (
            <ol className="text-start py-4">
                {data?.imageQualityLogic && (
                    <li>
                        <p>
                            Your image quality is very low. Please do this in a well-lit
                            environment.
                        </p>
                    </li>
                )}
                {data?.procedureValidationLogic && (
                    <li>
                        <p>You failed the procedure validation.</p>
                    </li>
                )}
                {data?.screenPlayLogic && (
                    <li>
                        <p>This check was done with a recorded video with screen play.</p>
                    </li>
                )}
                {!data?.screenPlayLogic && data?.faceGenuinenessLogic && (
                    <li>
                        <p>
                            Your face is not clear enough. Please do this in a well-lit environment.
                        </p>
                    </li>
                )}
                {data?.glassLogic && (
                    <li>
                        <p>Use of glasses is not allowed.</p>
                    </li>
                )}
                {(data?.leftEyesStatusLogic || data?.rightEyesStatusLogic) && (
                    <li>
                        <p>One of your eyes is closed. Please open your eyes and try again.</p>
                    </li>
                )}
                {data?.mouthOpenLogic && (
                    <li>
                        <p>You opened your mouth. Please close your mouth and try again.</p>
                    </li>
                )}
            </ol>
        ) : (
            <p className="pb-4 pt-3 font-13">Please try again in a well-lit environment.</p>
        )}

        <div className="col-7 mx-auto">
            <Button name="Redo Facial Verification" cls="btn--lg" handleClick={onRedo} />
        </div>
    </div>
);

export const FacialVerificationSuccess = () => {
    return (
        <div className="verification_result text-center">
            <SuccessIcon />
            <h3 className="fw-bold mt-4">Facial Verification Completed!</h3>
            <p className="pb-4 pt-3 font-13">
                Your identity has been successfully verified. You may now close this window.
            </p>
        </div>
    );
};
